import React, { useEffect, useState } from 'react';
import {
  App,
  Empty, Select, Spin, Typography,
} from 'antd';
import { useParams } from 'react-router-dom';
import {
  useMarathonId, useMarathonEntityCopy, MarathonTraining,
} from '../../../../../hooks/api/marathons';
import { LevelType, Option, PlaceType } from '../../../../../types';
import { sortTrainings } from '../../Form/EntitiesCollapse/sortUtils';
import { useSimpleModal } from '../../../../Common/Modal/Simple';
import { LevelEnum, PlaceEnum } from '../../../../../enums/trainings';

interface CopySelectProps {
  currentPlace: PlaceType | undefined;
  currentLevel: LevelType | undefined;
  onCopy: (response: MarathonTraining) => void;
}

function CopySelect({ currentPlace, currentLevel, onCopy }: CopySelectProps) {
  const { message } = App.useApp();
  const { open, contextHolder } = useSimpleModal();
  const { marathonId = '', id: entityId = '' } = useParams<{ marathonId: string; id: string }>();
  const marathonById = useMarathonId();
  const marathonPostCopy = useMarathonEntityCopy<MarathonTraining>();

  const [value] = useState<string | null>(null);
  const [options, setOptions] = useState<Option[]>([]);

  useEffect(() => {
    if (marathonById.data?.trainings) {
      const newOptions: Option[] = sortTrainings(marathonById.data.trainings).map((training) => ({
        label: `${PlaceEnum[training.place]} (${LevelEnum[training.level]})`,
        value: training.id,
        disabled: training.place === currentPlace && training.level === currentLevel,
      }));

      setOptions(newOptions);
    }
  }, [marathonById.data?.shoppings]);

  const handleCopy = (selectedId: string) => {
    if (selectedId) {
      open({
        title: 'Копировать контент',
        content: `Вы уверены, что хотите копировать и заменить все данные в ${
          currentPlace && currentLevel ? `тренировке  "${PlaceEnum[currentPlace]} (${LevelEnum[currentLevel]})"`
            : 'текущей тренировке'}?`,
        cancelText: 'Отмена',
        centered: true,
        okText: 'Копировать',
        okType: 'primary',
        onOk: () => marathonPostCopy.fetch(undefined, `${marathonId}/trainings/${entityId}/copy-from/${selectedId}`)
          .then((res) => {
            if (res?.id) {
              message.success('Контент успешно скопирован.');
              onCopy(res);
            }
          }),
        maskClosable: true,
      });
    }
  };

  return (
    <>
      {contextHolder}
      <Select
        options={options}
        placeholder="Копировать из..."
        onFocus={() => { /** If there's no data yet - on first open of select do request to load options. */
          if (!marathonById.data) { marathonById.fetch(undefined, marathonId); }
        }}
        value={value}
        onChange={handleCopy}
        popupMatchSelectWidth={false}
        style={{ minWidth: '220px' }}
        loading={marathonById.loading}
        notFoundContent={(
          <Empty
            image={marathonById.loading ? <Spin size="default" /> : undefined}
            imageStyle={{ maxHeight: '50px', lineHeight: '50px' }}
            description={(
              <Typography.Text type="secondary">
                {marathonById.loading ? 'Загрузка...' : 'Нет данных'}
              </Typography.Text>
            )}
          />
        )}
      />
    </>
  );
}

export default CopySelect;
